var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgEndMeetingIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.222 7.2H1.778A1.79 1.79 0 0 0 0 9v7.2c0 .993.797 1.8 1.778 1.8h12.444A1.79 1.79 0 0 0 16 16.2V9c0-.993-.797-1.8-1.778-1.8ZM1.778 3.6h12.444v1.8H1.778V3.6ZM3.556 0h8.888v1.8H3.556V0Z",
  fill: "#FF7A7A"
})));
export { SvgEndMeetingIcon as ReactComponent };
export default __webpack_public_path__ + "10513cc33d63385bacc17e5e775837e9.svg";